module.exports = __webpack_public_path__ + "res/28-img_more_rtl.2240c0fd09432e883bb4c0f33e8fe5aa.png";